import en from './en'
import { flattenMessages } from './localeUtils'
import { MessageFormatElement, parse } from '@formatjs/icu-messageformat-parser'

const enFlat = flattenMessages(en)

function compileIntlMessages(messages: Record<string, string>): Record<string, MessageFormatElement[]> {
  return Object.entries(messages).reduce((acc, [key, value]) => {
    try {
      acc[key] = parse(value)
    } catch (err) {
      console.error(`parseMessages: ${err} on ${key}: message: ${value}`)
    }
    return acc
  }, {} as Record<string, MessageFormatElement[]>)
}

export const messages = {
  en: compileIntlMessages(enFlat)
}
